"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5275],{

/***/ 8866:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ResetPassword; }
/* harmony export */ });
/* harmony import */ var _data01_virt79212_domeenid_www_baltbaby_com_baltbaby_est_baltbaby_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _data01_virt79212_domeenid_www_baltbaby_com_baltbaby_est_baltbaby_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_data01_virt79212_domeenid_www_baltbaby_com_baltbaby_est_baltbaby_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7536);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(319);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1131);
/* harmony import */ var global_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(561);
/* harmony import */ var graphql_mutations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9592);
/* harmony import */ var hooks_auth_usePasswordErrors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5047);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4337);
/* harmony import */ var _UI_Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9968);
/* harmony import */ var _UI_Form_Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2979);
/* harmony import */ var _UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5653);
/* harmony import */ var _UI_Primitives_Headings__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7133);
/* harmony import */ var _UI_Button_Variants_Primary__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6803);
/* harmony import */ var _UI_Modal_ReturnButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5209);
/* harmony import */ var _UI_Loader_Spinner__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7162);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


















function ResetPassword() {
    var ref9;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var token = (ref9 = router.query) === null || ref9 === void 0 ? void 0 : ref9.token;
    var ref1 = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_14__/* .useForm */ .cI)(), register = ref1.register, unregister = ref1.unregister, handleSubmit = ref1.handleSubmit, reset = ref1.reset, _formState = ref1.formState, errors = _formState.errors, isSubmitSuccessful = _formState.isSubmitSuccessful, setError = ref1.setError;
    var ref2 = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_15__/* .useAtom */ .KO)(global_store__WEBPACK_IMPORTED_MODULE_4__/* .resetPasswordModalAtom */ .Gn), 2), isOpen = ref2[0], setIsOpen = ref2[1];
    var ref3 = _slicedToArray((0,jotai__WEBPACK_IMPORTED_MODULE_15__/* .useAtom */ .KO)(global_store__WEBPACK_IMPORTED_MODULE_4__/* .authModalAtom */ .C0), 2), setAuthModalOpen = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("request"), resetType = ref4[0], setResetType = ref4[1];
    var isRequest = resetType === "request";
    var ref5 = _slicedToArray((0,_apollo_client__WEBPACK_IMPORTED_MODULE_16__/* .useMutation */ .D)(graphql_mutations__WEBPACK_IMPORTED_MODULE_5__/* .REQUEST_PASSWORD_RESET */ .AF), 2), requestPasswordReset = ref5[0], ref6 = ref5[1], requestLoading = ref6.loading;
    var ref7 = _slicedToArray((0,_apollo_client__WEBPACK_IMPORTED_MODULE_16__/* .useMutation */ .D)(graphql_mutations__WEBPACK_IMPORTED_MODULE_5__/* .RESET_PASSWORD */ .bk), 2), setNewPassword = ref7[0], ref8 = ref7[1], error = ref8.error, newPasswordLoading = ref8.loading;
    var onSubmit = function() {
        var _ref = _asyncToGenerator(_data01_virt79212_domeenid_www_baltbaby_com_baltbaby_est_baltbaby_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
            var ref;
            return _data01_virt79212_domeenid_www_baltbaby_com_baltbaby_est_baltbaby_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isRequest) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return requestPasswordReset({
                            variables: {
                                email: data.email
                            }
                        });
                    case 3:
                        _ctx.next = 8;
                        break;
                    case 5:
                        ;
                        _ctx.next = 8;
                        return setNewPassword({
                            variables: {
                                token: token,
                                email: (ref = router.query) === null || ref === void 0 ? void 0 : ref.email,
                                newPassword: data.password
                            }
                        });
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (token) {
            setResetType("new-password");
            unregister("email");
        }
    }, [
        token
    ]);
    // Set password errors manually
    (0,hooks_auth_usePasswordErrors__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, setError);
    var modalContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_9__/* .FlexColCenter */ .S, {
        as: "form",
        onSubmit: handleSubmit(onSubmit),
        pb: "2rem",
        children: [
            isRequest && !isSubmitSuccessful && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UI_Modal_ReturnButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                onClick: function() {
                    setIsOpen(false);
                    setAuthModalOpen(true);
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UI_Primitives_Headings__WEBPACK_IMPORTED_MODULE_10__/* .SectionTitle */ .NZ, {
                children: isRequest ? "Parooli taastamine" : isSubmitSuccessful ? "Uus parool" : "Vali uus parool"
            }),
            !isSubmitSuccessful ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: isRequest && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .xuv, {
                    as: "span",
                    color: "#2A2A2A",
                    children: "Salas\xf5na taastamiseks sisesta e-posti aadress"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_17__/* .Box */ .xuv, {
                        as: "span",
                        mt: "1rem",
                        maxW: 280,
                        textAlign: "center",
                        color: "#2A2A2A",
                        children: isRequest ? "Teie e-posti aadressile on saadetud link salas\xf5na taastamiseks" : "Teie salas\xf5na on muudetud"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UI_Button_Variants_Primary__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        h: "3rem",
                        w: "30%",
                        mt: "2rem",
                        onClick: function() {
                            setIsOpen(false);
                            // Reset form
                            reset();
                            // Clear query params
                            router.replace("/", undefined, {
                                shallow: true
                            });
                        },
                        children: "Ok"
                    })
                ]
            }),
            !isSubmitSuccessful && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_UI_Primitives_FlexBox__WEBPACK_IMPORTED_MODULE_9__/* .FlexBox */ .h, {
                dir: "column",
                w: "80%",
                pt: "2rem",
                children: [
                    isRequest ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UI_Form_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread({
                        type: "email",
                        placeholder: "E-post"
                    }, register("email", {
                        required: "Kohustuslik v\xe4li"
                    }), {
                        error: errors.email
                    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UI_Form_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread({
                        type: "password",
                        placeholder: "Uus parool"
                    }, register("password", {
                        required: "Kohustuslik v\xe4li"
                    }), {
                        error: errors.password
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UI_Button_Variants_Primary__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                        type: "submit",
                        h: "3rem",
                        w: "50%",
                        mt: "2rem",
                        alignSelf: "center",
                        children: requestLoading || newPasswordLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UI_Loader_Spinner__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}) : isRequest ? "Saada" : "Kinnita"
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UI_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        hideClose: true,
        isShown: isOpen,
        content: modalContent,
        width: {
            _: "90vw",
            sm_tablet: 500,
            tablet: 590
        },
        p: {
            _: "2.5rem 1rem",
            desktop: "2.5rem 4rem 1rem"
        },
        h: {
            _: "50vh",
            desktop: "100%"
        }
    });
};


/***/ }),

/***/ 6803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PrimaryButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8356);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


/**
 * PrimaryButton
 *
 * The main button component
 *
 * @prop {ReactNode | ReactNodeArray} children - button content
 */ function PrimaryButton(_param) {
    var children = _param.children, rest = _objectWithoutProperties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
        bg: "teal-100",
        hoverBg: "teal-300",
        color: "white"
    }, rest, {
        children: children
    }));
};


/***/ }),

/***/ 2979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4337);
/* harmony import */ var _UI_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1040);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var Input = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xuv, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xuv, _objectSpread({
                ref: ref,
                as: "input",
                type: props.type || "text",
                placeholder: props.placeholder,
                disabled: props.disabled,
                w: "100%",
                p: "12px",
                border: "0.8px solid #a8a9ba",
                borderRadius: "7px",
                borderColor: props.error && "#e54f4f",
                hoverBorderColor: "gray",
                focusBorder: "1.6px solid gray",
                focusOutline: 0,
                disabledBackgroundColor: "#F9F9F9"
            }, props)),
            props.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_utils__WEBPACK_IMPORTED_MODULE_2__/* .ErrorMessage */ .Bc, {
                children: props.error.message
            })
        ]
    });
});
Input.displayName = "Input";
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 7162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Spinner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 24px;\n  height: 24px;\n  position: relative;\n  margin: 0 auto;\n  animation: chase 2.5s infinite linear both;\n\n  .dot {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    animation: chase-dot 2s infinite ease-in-out both;\n  }\n\n  .dot:before {\n    content: '';\n    display: block;\n    width: 25%;\n    height: 25%;\n    background: ",
        ";\n    border-radius: 100%;\n    animation: chase-dot-before 2s infinite ease-in-out both;\n  }\n\n  .dot:nth-child(1) {\n    animation-delay: -1.1s;\n  }\n  .dot:nth-child(2) {\n    animation-delay: -1s;\n  }\n  .dot:nth-child(3) {\n    animation-delay: -0.9s;\n  }\n  .dot:nth-child(4) {\n    animation-delay: -0.8s;\n  }\n  .dot:nth-child(5) {\n    animation-delay: -0.7s;\n  }\n  .dot:nth-child(6) {\n    animation-delay: -0.6s;\n  }\n  .dot:nth-child(1):before {\n    animation-delay: -1.1s;\n  }\n  .dot:nth-child(2):before {\n    animation-delay: -1s;\n  }\n  .dot:nth-child(3):before {\n    animation-delay: -0.9s;\n  }\n  .dot:nth-child(4):before {\n    animation-delay: -0.8s;\n  }\n  .dot:nth-child(5):before {\n    animation-delay: -0.7s;\n  }\n  .dot:nth-child(6):before {\n    animation-delay: -0.6s;\n  }\n\n  @keyframes chase {\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes chase-dot {\n    80%,\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes chase-dot-before {\n    50% {\n      transform: scale(0.4);\n    }\n    100%,\n    0% {\n      transform: scale(1);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var SpinnerLoader = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .ZPm.div(_templateObject(), function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : "#fff";
});
function Spinner(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SpinnerLoader, {
        color: color,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "dot"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "dot"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "dot"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "dot"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "dot"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "dot"
            })
        ]
    });
};


/***/ }),

/***/ 5209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ReturnButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4337);


function ReturnButton(param) {
    var onClick = param.onClick;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
        as: "span",
        role: "button",
        onClick: onClick,
        "aria-label": "Return from modal",
        position: "absolute",
        left: "2rem",
        top: "3rem",
        cursor: "pointer",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Arrow, {})
    });
};
var Arrow = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "28",
        height: "28",
        viewBox: "0 0 28 28",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "Group_1381",
            "data-name": "Group 1381",
            transform: "translate(-692 -235)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
                    id: "Group_218",
                    "data-name": "Group 218",
                    transform: "translate(-498 13)",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        id: "Ellipse_24",
                        "data-name": "Ellipse 24",
                        cx: "14",
                        cy: "14",
                        r: "14",
                        transform: "translate(1190 222)",
                        fill: "#efefef"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_421",
                    "data-name": "Path 421",
                    d: "M9609.712,6339.933H9595.16",
                    transform: "translate(-8896.436 -6091)",
                    fill: "none",
                    stroke: "#707070",
                    strokeLinecap: "round",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_422",
                    "data-name": "Path 422",
                    d: "M0,5.577,5.578,0l5.577,5.577",
                    transform: "translate(698.725 254.51) rotate(-90)",
                    fill: "none",
                    stroke: "#707070",
                    strokeLinecap: "round",
                    strokeLinejoin: "bevel",
                    strokeWidth: "2"
                })
            ]
        })
    });
};


/***/ }),

/***/ 9968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ Modal; }
/* harmony export */ });
/* unused harmony exports Backdrop, ModalWrapper, ModalContent */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3935);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4337);
/* harmony import */ var hooks_UI_useLockBodyScroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2291);
/* harmony import */ var _UI_Icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9430);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background: #3d4d4f;\n  opacity: 0.6;\n  z-index: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 700;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  margin: auto;\n  border-radius: 22px;\n  background-color: white;\n  z-index: 100;\n  overflow-y: auto;\n\n  span.closeModal {\n    position: absolute;\n    top: 1.5rem;\n    right: 2rem;\n    cursor: pointer;\n    z-index: 101;\n\n    @media (max-width: desktop) {\n      top: 1rem;\n      right: 1rem;\n    }\n\n    svg {\n      @media (min-width: desktop) {\n        transform: scale(1.2);\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var Backdrop = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div */ .ZPm.div(_templateObject());
var ModalWrapper = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].divBox */ .ZPm.divBox(_templateObject1());
var ModalContent = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].divBox */ .ZPm.divBox(_templateObject2());
function Modal(_param) {
    var isShown = _param.isShown, hide = _param.hide, content = _param.content, width = _param.width, hideClose = _param.hideClose, rest = _objectWithoutProperties(_param, [
        "isShown",
        "hide",
        "content",
        "width",
        "hideClose"
    ]);
    (0,hooks_UI_useLockBodyScroll__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(isShown);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onKeyDown = function(e) {
            if (e.keyCode === 27 && isShown) {
                hide();
            }
        };
        document.addEventListener("keydown", onKeyDown, false);
        return function() {
            document.removeEventListener("keydown", onKeyDown, false);
        };
    }, [
        isShown,
        hide
    ]);
    var modal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Backdrop, {
                onClick: hide
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalWrapper, {
                "aria-modal": true,
                tabIndex: -1,
                role: "dialog",
                w: width,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalContent, _objectSpread({}, rest, {
                    children: [
                        !hideClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            role: "button",
                            "aria-label": "Close modal",
                            className: "closeModal",
                            onClick: hide,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_UI_Icons__WEBPACK_IMPORTED_MODULE_4__/* .Close */ .x8, {})
                        }),
                        content
                    ]
                }))
            })
        ]
    });
    return isShown ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(modal, document.body) : null;
};


/***/ }),

/***/ 1028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ClientOnly; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4337);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



function ClientOnly(_param) {
    var children = _param.children, rest = _objectWithoutProperties(_param, [
        "children"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasMounted = ref[0], setHasMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHasMounted(true);
    }, []);
    if (!hasMounted) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, _objectSpread({}, rest, {
        children: children
    }));
};


/***/ }),

/***/ 7133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kg": function() { return /* binding */ SectionTitleSmall; },
/* harmony export */   "NZ": function() { return /* binding */ SectionTitle; },
/* harmony export */   "gI": function() { return /* binding */ CategoryTitle; }
/* harmony export */ });
/* unused harmony export PageTitle */
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4337);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7248);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  font-size: large;\n  font-weight: bold;\n  line-height: 1.3;\n  color: #52c1d3;\n  @media (min-width: desktop) {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: medium;\n  font-weight: 700;\n  line-height: 1.35;\n\n  @media (min-width: desktop) {\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  font-weight: 500;\n\n  @media (min-width: desktop) {\n    font-size: medium;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      font-size: small;\n\n      span {\n        margin-right: 0.5rem;\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: small;\n  font-weight: 700;\n  line-height: 1.2;\n  color: teal-300;\n  text-transform: uppercase;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var PageTitle = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h1Box */ .ZPm.h1Box(_templateObject(), function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__.th.fontSize("2.5rem");
});
var SectionTitle = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h2Box */ .ZPm.h2Box(_templateObject1(), function(param) {
    var fontSize = param.fontSize;
    return fontSize !== null && fontSize !== void 0 ? fontSize : _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__.th.fontSize("xlarge");
});
var SectionTitleSmall = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZPm)(SectionTitle)(_templateObject2());
var CategoryTitle = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].h3Box */ .ZPm.h3Box(_templateObject4(), function(param) {
    var withIcon = param.withIcon;
    return withIcon && (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .ivY)(_templateObject3());
});


/***/ }),

/***/ 1040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B4": function() { return /* binding */ CrossOut; },
/* harmony export */   "Bc": function() { return /* binding */ ErrorMessage; },
/* harmony export */   "Lb": function() { return /* binding */ FlexCenter; },
/* harmony export */   "x1": function() { return /* binding */ HideInput; }
/* harmony export */ });
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4337);
/* harmony import */ var _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7248);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  margin-top: calc(0.125rem / 2 * -1);\n  border-bottom: 0.125rem solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n  clip-path: inset(50%);\n  white-space: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: inline-flex;\n  justify-content: flex-end;\n  padding-right: 0.25rem;\n  color: #e54f4f;\n  font-size: 14px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var FlexCenter = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .ivY)(_templateObject());
var CrossOut = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .ivY)(_templateObject1(), _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_1__.th.color("blue-200"));
var HideInput = (0,_xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* .css */ .ivY)(_templateObject2());
var ErrorMessage = _xstyled_styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].spanBox */ .ZPm.spanBox(_templateObject3());


/***/ }),

/***/ 2291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLockBodyScroll; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function useLockBodyScroll(isShown) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isShown) {
            document.body.style.overflowY = "hidden";
        }
        return function() {
            return document.body.style.overflowY = "visible";
        };
    }, [
        isShown
    ]);
};


/***/ }),

/***/ 5047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ usePasswordErrors; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

function usePasswordErrors(error, setError) {
    var setPasswordError = function(message) {
        return setError("password", {
            type: "manual",
            message: message
        });
    };
    // Validate password length and classes of characters used (errors from Magento)
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (error) {
            if (error.message.includes("at least 8 characters")) {
                setPasswordError("Parool peab sisaldama v\xe4hemalt 8 t\xe4hem\xe4rki");
            }
            if (error.message.includes("different classes of characters")) {
                setPasswordError("Parool peab sisaldama suuri t\xe4hti ja numbreid");
            }
        }
    }, [
        error
    ]);
};


/***/ })

}]);